// @flow

import $ from "../vendor/jquery";
import AppConfig from "../config";
import _ from "underscore";
import type {IntegerType} from "../model";
import Popup from "../Popup";
import global from "../Grobot/Global";
import rootStore from "../stores";

/**
 * Calculates angle between line and x-axle in degrees based by coordinates of two points.
 * Math behind this:
 * 	y2 / (x2 - x0) = y1 / (x1 - x0)  => x0 = (y2 * x1 - y1 * x2) / (y2 - y1)
 * 	tanAlpha = y2 / (x2 - x0)
 * @protected
 * @param x1
 * @param y1
 * @param x2
 * @param y2
 * @returns {number}
 */
export function calcAngle(x1: IntegerType, y1: IntegerType, x2: IntegerType, y2: IntegerType) : number {
    // Division by zero check:
    if (y2 === y1) return 0;
    if (x1 > x2) {
        let tmp = x2;
        x2 = x1; x1 = tmp;
    }


    let x0 = (y2*x1 - y1*x2) / (y2 - y1);
    if (x2 === x0) return 90;
    let tanAlpha = y2 / (x2 - x0);
    let alpha = Math.atan(tanAlpha);

    return Math.round(10 * alpha*180 / Math.PI) / 10;
}

export function limit_timestamp(str) {
    let n = 19;
    if (!str) return "";
    if (str.length > n) return str.substring(0, n).replace("T", " "); //+"...";
    return str;
}

/**
 * Meetod aktsepteerib samu parameetreid, mis $.ajax(), kuid täiendavalt
 * väärtustab "dataType" = "json", "contentType" = "application/json; charset=utf-8"
 * ja teosendab "data" parameetri väärtuse JSON stringiks, kui see oli objekt.
 *
 * @param options
 */
export function jsonAjax(options: {...}): void {
    options = {
        statusCode: {
            401: function () {
                // Authentication required
                console.log("jsonAjax(): STATUS 401: invalidating session, url: " + options.url);
                rootStore.sessionStore.invalidate();
            },
            403: function () {
                // Need to reauthenticate
                console.log("jsonAjax(): STATUS 403: invalidating session, url: " + options.url);
                rootStore.sessionStore.invalidate();
            }
        },
        ...options,
        dataType: "json",
        cache: false,
        crossDomain: AppConfig.USE_CROSSDOMAIN,
        contentType: "application/json",
        beforeSend: function (xhr) {
            let session = rootStore.sessionStore.getSession();
            if (session != null && session.token != null)
                xhr.setRequestHeader('Authorization', 'Bearer ' + session.token);
        },
    };
    if (typeof options.data === "object") options.data = JSON.stringify(options.data);
    $.ajax(options);
}

/**
 * Menüüvaliku aktiveerimine
 *
 * @param item Menüüvaliku ID
 */
export function activateMenuItem(item: string): void {
    $("ul.nav > li").removeClass("active");
    $("#" + item + "_li").addClass("active");
}

export function htmlEncode(value: string): string {
    //create an in-memory div, set its inner text(which jQuery automatically encodes)
    //then grab the encoded contents back out.  The div never exists on the page.
    return $('<div/>').text(value).html();
}

export function is_numeric(num) {
    //return (num >=0 || num < 0);
    return typeof num === 'number' && isFinite(num);
}

export function getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)').exec(window.location.search)||[null,""])[1].replace(/\+/g, '%20'))||null;
}

export function getCurrentPage() {
    let page = window.location.href.substring(window.location.href.lastIndexOf("/")+1);
    let i = page.indexOf("#");
    if (i >= 0) page = page.substring(0, i);
    i = page.indexOf("?");
    if (i >= 0) page = page.substring(0, i);
    return page;
}

export function getProductCode(codeVariant: ?string): ?string {
    if (codeVariant == null) return null;
    let arr = codeVariant.split('_');
    return arr[0];
}

/*
function getProductVariant(codeVariant) {
    if (codeVariant === null) return null;
    codeVariant = codeVariant.toString();
    var arr = codeVariant.split('_');
    if (arr.length < 2) return null;
    return arr[1];
}
*/

export function asNumber(val: ?number, def: number = 0): number {
    if (val == null || !_.isNumber(val) || isNaN(val)) return def;
    return val;
}

export function asBoolean(val: ?boolean, def: boolean = false): boolean {
    if (val == null || !_.isBoolean(val)) return def;
    return val;
}

export function asString(val: any, def: string = ""): string {
    if (val == null) return def;
    if (!_.isString(val)) return val.toString();
    return val;
}

export function getInt(val: ?string): ?IntegerType {
    if (val == null) return null;
    let res = parseInt(val);
    if (isNaN(res)) return null;
    return res;
}

export function getDecimal(val: ?string): ?number {
    if (val == null) return null;
    let res = parseFloat(val);
    if (isNaN(res)) return null;
    return res;
}

export function getBoolean(val: ?string | boolean): ?boolean {
    if (val == null) return null;
    if (_.isBoolean(val)) return val;
    if (_.isNumber(val)) return (val > 0);
    if (_.isString(val)) {
        switch (val.toLowerCase()) {
            case 'true':
                return true;
            case 'false':
                return false;
            default:
                return null;
        }
    }
    return null;
}
